import { documentReady } from './utils';

const StickyManager = {
    initialize: () => {

        documentReady(() => {
            StickyManager.getCurrentLetter();
            window.addEventListener('scroll', StickyManager.getCurrentLetter);
            StickyManager.accordeonScoll();
        });
    },

    accordeonScoll: () => {
        const btns = document.querySelectorAll('.bk-accordion__list-item-label');

        btns.forEach(btn => {
            btn.addEventListener('click', () => {
                setTimeout(() => {
                    if (btn.getAttribute('aria-expanded') === 'true') {
                        const elemPos = btn.getBoundingClientRect().top;
                        const offsetPosition = elemPos + window.pageYOffset - 100;
                        window.scrollTo({
                            top: offsetPosition,
                            behaviour: 'smooth'
                        })
                    }
                }, 300);
            })
        })
    },

    getCurrentLetter: () => {
        const stickyBit = document.querySelector('.lgmp-terms');
        const letters = document.querySelectorAll('span[id^="letter-"]');
        const linksToLetters = document.querySelectorAll('.lgmp-terms__link');
        
        if(stickyBit.getBoundingClientRect().bottom < 100) {
            stickyBit.dataset.currentlySticky = true;
        } else {
            stickyBit.dataset.currentlySticky = false;
        }

        letters.forEach(l => {
            if(l.getBoundingClientRect().top <= stickyBit.offsetHeight) {
                linksToLetters.forEach(link => {
                    link.closest('.lgmp-terms__letter').classList.remove('lgmp-terms__letter--active');
                });
                document.querySelector('.lgmp-terms__link[href="#' + l.id + '"]').closest('.lgmp-terms__letter').classList.add('lgmp-terms__letter--active');
            }
        });
        
    }
}

StickyManager.initialize();

export default StickyManager;
